import { withListOverflow } from "../../v2/components/ListOverflow.jsx";
export const DataReconciliationPanel = withListOverflow(ReconciliationListOwner);
import React, { useEffect, useState } from "react";
import { T } from "../../app/tokens.js";
import { DataTabHeading } from "../../components/DataTabHeading.jsx";
import { getDataReconciliationFindings } from "../../data/adminClient.js";

const CELL_STYLE = {
  padding: "9px 10px",
  borderBottom: `1px solid ${T.border}`,
  textAlign: "left",
  verticalAlign: "top",
  fontSize: T.fsSm,
  color: T.dark,
};

function displayDate(value) {
  if (!value) return "—";
  if (value instanceof Date) return value.toISOString().slice(0, 10);
  return String(value).slice(0, 10);
}

function ReconciliationListOwner() {
  const [findings, setFindings] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getDataReconciliationFindings()
      .then((result) => {
        if (!cancelled) setFindings(result);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <section data-testid="data-reconciliation-panel">
      <DataTabHeading description="Active arithmetic mismatches detected in imported headcount and lease cost data. This list is read-only.">
        Data reconciliation
      </DataTabHeading>
      {findings === null && !error && (
        <p data-testid="reconciliation-loading" role="status" style={{ color: T.mid }}>
          Loading reconciliation findings…
        </p>
      )}
      {error && (
        <p data-testid="reconciliation-error" role="alert" style={{ color: T.red }}>
          Couldn't load reconciliation findings.
        </p>
      )}
      {findings?.length === 0 && (
        <p data-testid="reconciliation-empty" role="status" style={{ color: T.mid }}>
          No active reconciliation findings.
        </p>
      )}
      {findings?.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table data-testid="reconciliation-findings-table" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["Dataset", "Record / period", "Invariant", "Expected", "Actual", "Residual (actual − expected)", "First detected"].map((label) => (
                  <th key={label} scope="col" style={{ ...CELL_STYLE, fontWeight: T.fwSemibold, color: T.mid }}>
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {findings.map((finding) => (
                <tr key={finding.id}>
                  <td style={CELL_STYLE}>{finding.dataset}</td>
                  <td style={CELL_STYLE}>
                    <div>{finding.recordKey}</div>
                    <div style={{ color: T.mid }}>{finding.period}</div>
                  </td>
                  <td style={CELL_STYLE}>{finding.invariant}</td>
                  <td style={CELL_STYLE}>{finding.expectedValue}</td>
                  <td style={CELL_STYLE}>{finding.actualValue}</td>
                  <td style={CELL_STYLE}>{finding.residualValue}</td>
                  <td style={CELL_STYLE}>{displayDate(finding.firstDetectedAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}